package ru.dinarastepina.fabvocab.web.theme

import org.jetbrains.compose.web.css.CSSColorValue

data class PosColors(
    val text: CSSColorValue,
    val background: CSSColorValue,
    val border: CSSColorValue,
    val progress: CSSColorValue,
)

fun posThemeFor(partOfSpeech: String?): PosColors = when (partOfSpeech?.lowercase()) {
    "adjective" -> PosColors(
        text = Indigo600,
        background = Indigo50,
        border = Indigo100,
        progress = Emerald400,
    )
    "verb" -> PosColors(
        text = Rose600,
        background = Rose50,
        border = Rose100,
        progress = Emerald400,
    )
    "noun" -> PosColors(
        text = Emerald600,
        background = Emerald50,
        border = Emerald100,
        progress = Emerald400,
    )
    "adverb" -> PosColors(
        text = Amber600,
        background = Amber50,
        border = Amber100,
        progress = Emerald400,
    )
    else -> PosColors(
        text = Indigo600,
        background = Indigo50,
        border = Indigo100,
        progress = Emerald400,
    )
}
